module.exports = __webpack_public_path__ + "static/media/loginBG2.126921c5.jpg";